import { render, staticRenderFns } from "./wdbookactive.vue?vue&type=template&id=6958379d&scoped=true"
import script from "./wdbookactive.vue?vue&type=script&lang=js"
export * from "./wdbookactive.vue?vue&type=script&lang=js"
import style0 from "./wdbookactive.vue?vue&type=style&index=0&id=6958379d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../../../../../../opt/build-cache/yunying/node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6958379d",
  null
  
)

export default component.exports